import { HipaaSignatureInfo } from "../models/HipaaSignatureInfo";
import {getEzAppToken} from "./Utilities";
import {EzAppBaseUrl} from "./Store";
import {get} from "svelte/store";
import { SetIncidentalError} from "./ErrorService";

export class HipaaAuthorizationService {

    public async GetHipaaForm(state: string) {

            const  url = get(EzAppBaseUrl) + "Telelife/GetHipaaForm?State="  + state;

            const headers = {
                'Authorization': getEzAppToken()
            }
            const response =  await fetch(url, {method: 'GET',
                cache: 'no-cache',
                headers
            });
            if (response.ok) {
                return await response.json();
            }
            else {
               SetIncidentalError();
            }

    }

    public async SignHipaaForm(signatureInfo: HipaaSignatureInfo){

            const headers = {
                "Content-type": "application/json",
                'Authorization': getEzAppToken()
            }

            const  url = get(EzAppBaseUrl) + "Telelife/SignHipaaForm";

            const response =  await fetch(url, {method: 'POST',
                body: JSON.stringify(signatureInfo),
                cache: 'no-cache',
                headers
            });

        if (response.ok) {
            return await response.json();
        }
        else {
           SetIncidentalError();
        }
    }
}
